import apiClient from '@/services/api_client';

export type WeekOverWeekCount = {
    current: number;
    previous: number;
};

export type WeekOverWeekPercent = {
    current: number | null;
    previous: number | null;
};

export type ReportKPIs = {
    accounts_created: WeekOverWeekCount;
    onboarding_pending_percent: WeekOverWeekPercent;
    accounts_with_multiple_connections: number;
    active_accounts: number;
};

export async function getElqanoAdminReportKpis(
    tenantId: string
): Promise<ReportKPIs> {
    const response = await apiClient.get(
        `/elqano-admin-report?tenant_id=${encodeURIComponent(tenantId)}`
    );
    return await response.json();
}

export async function downloadElqanoAdminReport(
    tenantId: string
): Promise<Blob> {
    const response = await apiClient.get(
        `/elqano-admin-report/download?tenant_id=${encodeURIComponent(tenantId)}`
    );
    return await response.blob();
}

export async function downloadGoogleAdsConversions(
    tenantId: string
): Promise<Blob> {
    const response = await apiClient.get(
        `/elqano-admin-report/google-ads-conversions?tenant_id=${encodeURIComponent(tenantId)}`
    );
    return await response.blob();
}
